import { useCallback, useRef, useEffect } from 'react';
import { EditorPopupParams, EditorPopupsProps } from '../with-editor-popups';

const handle = ({ column, rowNode, ePopup }: EditorPopupParams): boolean => {
  if (column?.getId() !== 'status' || rowNode.id !== 'provisional') {
    return false;
  }

  /* eslint-disable no-param-reassign */
  ePopup.style.border = '2px solid var(--blue-60)';
  ePopup.style.borderRadius = '0';
  ePopup.style.left = `${parseInt(ePopup.style.left, 10) - 1}px`;
  ePopup.style.boxSizing = 'content-box';
  ePopup.style.height = '36px';
  /* eslint-enable no-param-reassign */

  return true;
};

export const useOnPopup = (actualOnPopup?: EditorPopupsProps['onPopup']) => {
  const onPopupRef = useRef<Required<EditorPopupsProps>['onPopup'] | null>(
    actualOnPopup ?? null,
  );
  const onPopup = useCallback(
    (params: EditorPopupParams) =>
      onPopupRef.current?.(params) ?? false ? true : handle(params),
    [onPopupRef],
  );

  useEffect(() => {
    onPopupRef.current = actualOnPopup ?? null;
  }, [onPopupRef, actualOnPopup]);

  return onPopup;
};
